<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay" md="10">
    <v-card class="mb-6">
      <v-card-title>Get CS from QR Code</v-card-title>
      <v-card-title>
        <v-form @submit.prevent="submitQR">
          <v-row>
            <v-col class="text-center">
              <v-text-field
                v-model="form.qrcodeid.value.value"
                :error-messages="form.qrcodeid.errorMessage.value"
                label="QR Code"
              />
            </v-col>
            <v-col class="text-center" cols="auto">
              <v-btn class="fill-height" type="submit">Submit</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-title>
    </v-card>
    <template v-if="park">
      <v-card class="mb-6">
        <v-card-text>
          <v-row>
            <v-col class="text-center" cols="6" style="max-width: 50%;">
              <ul class="text-body-1" style="list-style-type: none;">
                <li><b>Parkname:</b> {{ park['name'] }}</li>
                <li><b>Status: </b>
                  <v-icon
                    :color="statusColor"
                    size="32"
                    icon="mdi-circle"
                    style="background-color: black; border-radius: 50%;"
                  />
                </li>
                <li></li>
              </ul>
            </v-col>
            <v-col class="text-center" cols="6" style="max-width: 50%;">
              <l-map :zoom="zoom" :center="[mapLat, mapLon]"
                     style="width: 80%; height: 300px; margin-left: auto; margin-right: auto;">
                <l-tile-layer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  layer-type="base"
                  name="OpenStreetMap"
                />
                <l-marker :visible="showMarker" :lat-lng="[park.latitude, park.longitude]"/>
              </l-map>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card variant="outlined" class="mb-6">
        <v-row class="ma-2">
          <v-col cols="12" sm="4" md="4"
                 v-for="cs in park['chargingstations'].sort((a,b) => objComparatorNumber(a,b,'park_bnum'))"
                 :key="cs['id']">
            <v-card class="text-center">
              <ul class="text-body-1" style="list-style-type: none;">
                <li><b>Park Bnum:</b> {{ cs['park_bnum'] }}</li>
                <li><b>Qrcode:</b> {{ cs['qrcodeid'] || 'No' }}</li>
                <li><b>BNUM:</b> {{ cs['bnum'] }}</li>
                <li><b>Power:</b> {{ cs['last_power']?.['power'] ?? 'no data' }}</li>
                <li><b>Last Date:</b> {{ cs['timestamp'] }}</li>
                <li></li>
              </ul>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="text-center">
        <v-table>
          <b>Last recharges at the charging station</b><br/>
          Do you need this feature? Ask Federico to implement it!
        </v-table>
      </v-card>
    </template>
  </PanelPage>
</template>

<script setup>
import PanelPage from "../components/PanelPage.vue";
import { ref, computed } from "vue";
import { fetchCSByQR, fetchParkById } from "../remote/park.js";
import * as yup from 'yup';
import { useForm } from 'vee-validate';
import { getFormFromSchema, objComparatorNumber } from "../utils.js";
import { LMap, LTileLayer, LMarker } from "@vue-leaflet/vue-leaflet";


// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);
const chst = ref(null);
const park = ref(null);
const zoom = ref(4);
const mapLat = ref(47.41322);
const mapLon = ref(8.219482);
const showMarker = ref(false);

// Form
// noinspection JSCheckFunctionSignatures
const schema = yup.object({
  qrcodeid: yup.number().integer().required(),
});

const { handleSubmit } = useForm({
  validationSchema: schema
});

const form = getFormFromSchema(schema);

// noinspection JSValidateTypes
const submitQR = handleSubmit(async (values) => {
  loadingOverlay.value = true;
  try {
    chst.value = await fetchCSByQR(values.qrcodeid);
    park.value = await fetchParkById(chst.value['park']);
  } catch (e) {
    chst.value = null;
    park.value = null;
    mapLat.value = 47.41322;
    mapLon.value = 8.219482;
    zoom.value = 4;
    showMarker.value = false;
    loadingOverlay.value = false;
    useAlerts.value.errorAlert("QR code non trovato", '');
    return;
  }
  mapLat.value = park.value.latitude;
  mapLon.value = park.value.longitude;
  zoom.value = 14;
  showMarker.value = true;
  loadingOverlay.value = false;
});

const statusColor = computed(() => {
  console.log(chst.value);
  if (chst.value === null || chst.value['last_power'] === null) return '#808080'; // Not installed
  const last_online = new Date(chst.value['last_power']['timestamp']);
  const current_date = new Date();
  const diff_in_sec = (current_date - last_online) / 1000;
  const online = diff_in_sec < 300;
  if (park.value.installed && online) {
    return '#00FF00'; // Installed and online
  } else if (!park.value.installed) {
    return '#808080'; // Not installed
  } else {
    return '#FF0000'; // Installed but not online
  }
});

</script>

<style scoped>

</style>
